import React from 'react';
import { DateRange } from 'react-day-picker';
import { TrafficRetentionChart } from '../../traffic/TrafficRetentionChart';
import { RetentionSummaryTable } from '../../retention/RetentionSummaryTable';
import { usePitchModal } from '../../pitch/usePitchModal';
import { PitchConfigModal } from '../../pitch/PitchConfigModal';
import { PitchQuickModal } from '../../pitch/PitchQuickModal';
import type { VideoPitch } from '@/types/pitch';

interface RetentionTabContentProps {
  date: DateRange | undefined;
  videoId: string | null;
  videoMP4?: string | null;
  metricsEnhanced?: any;
}

export function RetentionTabContent({
  date,
  videoId,
  videoMP4,
  metricsEnhanced
}: RetentionTabContentProps) {
  // Usar os dados reais do metricsEnhanced
  const isLoading = metricsEnhanced?.isLoading;
  const summary = metricsEnhanced?.summary;
  const retentionTimeline = metricsEnhanced?.retentionTimeline || [];
  const videoInfo = metricsEnhanced?.videoInfo;
  const pitches: VideoPitch[] = videoInfo?.pitches ?? [];

  const timelineData = retentionTimeline.map((point: any) => ({
    time: point.time_seconds,
    retention: point.retention_pct,
    viewers_count: point.viewers_count,
  }));

  // Qual modal de pitch está aberto, e para qual pitch
  const pitchModal = usePitchModal();

  // Depois de salvar, refaz o consolidado: a retenção de cada pitch é calculada no backend.
  const refetchMetrics = () => metricsEnhanced?.refetchMetrics?.();

  return (
    <div className="space-y-9">
      {/* Gráfico Premium */}
      <TrafficRetentionChart
        timelineData={timelineData}
        isLoading={isLoading}
        pitches={pitches}
        videoUrl={videoMP4}
      />

      {/* KPIs com gap de 18px */}
      {summary && (
        <RetentionSummaryTable
          summary={summary}
          isLoading={isLoading}
          pitches={pitches}
          onEditPitch={pitchModal.openQuick}
          onPitchDetails={pitchModal.openDetails}
          videoId={videoId}
          dateRange={date}
          conversionsPlatforms={metricsEnhanced?.conversions?.platforms || []}
        />
      )}

      {/* Modal Rápido (Canetinha) - criar, editar ou remover um pitch */}
      <PitchQuickModal
        isOpen={pitchModal.quickOpen}
        onClose={pitchModal.closeQuick}
        videoId={videoInfo?.id ?? null}
        pitches={pitches}
        editingPitchId={pitchModal.quickPitchId}
        durationInSeconds={videoInfo?.duration}
        onSaved={refetchMetrics}
      />

      {/* Modal Completo (Detalhes) - histograma do pitch clicado */}
      <PitchConfigModal
        isOpen={pitchModal.detailsOpen}
        onClose={pitchModal.closeDetails}
        videoId={videoInfo?.id ?? null}
        pitches={pitches}
        pitchId={pitchModal.detailsPitchId}
        durationInSeconds={videoInfo?.duration}
        timelineData={timelineData}
        onSaved={refetchMetrics}
      />
    </div>
  );
}
